import { isEmpty } from '@/utils/general/browserHelper'
import React from 'react'
import FilterCategory, { FilterLegs, RevampRtDivider } from './FilterCategory'
import StopsFilter from './stopsFilter'

const StopsFilterNew = ({
  stops,
  returnStops,
  clearFiltersCategoryWise,
  isPerAdultPricing,
  selectedFilters,
  onFilterChange,
  isRT,
  processedData,
  isRevamp = false,
}: any) => {
  const { source = '', destination = '' } = processedData || {}
  const showBothLegs = isRT && !isEmpty(returnStops?.options)
  const shared = { isPerAdultPricing, isRT, isRevamp }
  const onClear = () => clearFiltersCategoryWise(selectedFilters, isRT, 'stops')
  const selectedCount =
    (stops?.selectedValues?.length || 0) +
    (isRT && returnStops?.selectedValues?.length ? returnStops?.selectedValues?.length : 0)

  return (
    <FilterCategory count={selectedCount} isRevamp={isRevamp} title='Stops' onClear={onClear}>
      <FilterLegs isRevamp={isRevamp}>
        {!isEmpty(stops?.options) && (
          <StopsFilter
            {...shared}
            stops={stops}
            onFilterChange={onFilterChange}
            from={source}
            route={showBothLegs ? `${source} → ${destination}` : ''}
          />
        )}

        <RevampRtDivider show={!!isRevamp && showBothLegs} />

        {showBothLegs && (
          <StopsFilter
            {...shared}
            stops={returnStops}
            onFilterChange={(type, values) => onFilterChange(type, values, 0, 'returnLeg')}
            from={destination}
            route={`${destination} → ${source}`}
          />
        )}
      </FilterLegs>
    </FilterCategory>
  )
}

export default StopsFilterNew
